module.exports = __webpack_public_path__ + "img/collection-weddingRingsHearts.85a7604.webp";